module.exports = __webpack_public_path__ + "img/reason_04@2x.577114fb.png";